import * as React from "react";
const SvgLettersCase = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 15.8337V7.08366C2.5 6.31011 2.80729 5.56825 3.35427 5.02126C3.90125 4.47428 4.64312 4.16699 5.41667 4.16699C6.19021 4.16699 6.93208 4.47428 7.47906 5.02126C8.02604 5.56825 8.33333 6.31011 8.33333 7.08366V15.8337M2.5 10.8337H8.33333M17.5 10.0003V15.8337M11.6667 12.917C11.6667 13.6905 11.974 14.4324 12.5209 14.9794C13.0679 15.5264 13.8098 15.8337 14.5833 15.8337C15.3569 15.8337 16.0987 15.5264 16.6457 14.9794C17.1927 14.4324 17.5 13.6905 17.5 12.917C17.5 12.1434 17.1927 11.4016 16.6457 10.8546C16.0987 10.3076 15.3569 10.0003 14.5833 10.0003C13.8098 10.0003 13.0679 10.3076 12.5209 10.8546C11.974 11.4016 11.6667 12.1434 11.6667 12.917Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgLettersCase;
